import { http } from "./http";

export type RsvpEstado = "PENDIENTE" | "ASISTE" | "NO_ASISTE" | string;

export type RsvpResumenItem = {
  apellido: string;
  comentario: string | null;
  confirmadoEn: string | null;
  confirmados: number;
  email: string | null;
  esPrincipal: boolean;
  estado: RsvpEstado;
  grupoId: number;
  invitadoId: number;
  maxInvitados: number;
  nombre: string;
  nombreGrupo: string;
  relacion: string;
  rsvpId: number | null;
  telefono: string | null;
  tipoGrupo: string;
};

export type RsvpResumen = {
  asisten: number;
  eventoId: number;
  items: RsvpResumenItem[];
  noAsisten: number;
  pendientes: number;
  totalConfirmados: number;
  totalGrupos: number;
  totalInvitados: number;
};

export async function obtenerResumenRsvp(eventoId: number) {
  return http.request<RsvpResumen>(`/api/admin/eventos/${eventoId}/rsvp-resumen`, {
    method: "GET",
  });
}
